import request from '@/utils/request'


// 查询兴趣标签列表
export function listCampsiteInterestTag(query) {
  return request({
    url: '/biz/admin/campsite/campsite/interest/tag/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询兴趣标签分页
export function pageCampsiteInterestTag(query) {
  return request({
    url: '/biz/admin/campsite/campsite/interest/tag/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询兴趣标签详细
export function getCampsiteInterestTag(data) {
  return request({
    url: '/biz/admin/campsite/campsite/interest/tag/detail',
    method: 'get',
    params: data
  })
}

// 新增兴趣标签
export function addCampsiteInterestTag(data) {
  return request({
    url: '/biz/admin/campsite/campsite/interest/tag/add',
    method: 'post',
    data: data
  })
}

// 修改兴趣标签
export function updateCampsiteInterestTag(data) {
  return request({
    url: '/biz/admin/campsite/campsite/interest/tag/edit',
    method: 'post',
    data: data
  })
}

// 删除兴趣标签
export function delCampsiteInterestTag(data) {
  return request({
    url: '/biz/admin/campsite/campsite/interest/tag/delete',
    method: 'post',
    data: data
  })
}
